// src/routes/index.tsx
import { createFileRoute } from "@tanstack/react-router"
import App from "../App";

// Simple wrapper to test if App imports correctly
function TestAppWrapper() {
  try {
    return <App />;
  } catch (error) {
    return (
      <div style={{ padding: '20px', color: 'red', background: '#0a0f1a', minHeight: '100vh' }}>
        <h1>Error loading App component:</h1>
        <pre>{String(error)}</pre>
      </div>
    );
  }
}

export const Route = createFileRoute("/")({
  component: TestAppWrapper,
});
